module.exports = __webpack_public_path__ + "static/media/24h-meter.79e86f90.jpeg";